import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { DownloadTmFileService, DownloadTmFileType } from '@frontend-site/downloads/domain';

@Component({
    selector: 'p-request-status-cell-renderer',
    templateUrl: './request-status-cell-renderer.component.html',
    styleUrls: ['./request-status-cell-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestStatusCellRendererComponent implements ICellRendererAngularComp {
    status: string = '';
    resultLink: string = '';
    progressPercentage: number = 0;
    resultType: 'download' | 'test' | 'link' | null = null;

    constructor(private downloadService: DownloadTmFileService) {}

    refresh(params: ICellRendererParams): boolean {
        return true;
    }

    agInit(params: ICellRendererParams): void {
        this.status = params.data.status;
        this.resultLink = params.data.resultLink;
        this.progressPercentage = params.data.percentage;
        if (!!this.resultLink) {
            this.resultType = this.isDownloadFileLink() ? 'download' : this.isTestLink() ? 'test' : 'link';
        }
    }

    isDownloadFileLink() {
        return !!this.resultLink && this.resultLink.startsWith('https://panaya-assets');
    }

    isTestLink() {
        return this.resultLink.match(/execution\/tree\/\d*\/testDetails/);
    }

    downloadFile() {
        this.downloadService
            .downloadTMFileFromBrowser(
                DownloadTmFileType.AS_LONG_REQUEST_ATTACHMENT,
                undefined,
                undefined,
                undefined,
                undefined,
                this.resultLink
            )
            .subscribe();
    }
}
